import { createReducer, on } from '@ngrx/store';
import { initialProductState } from './product_state';
import { updateProduct } from './product_actions_creator';

export const productReducer = createReducer(
  initialProductState,
  on(updateProduct, (state, action) => ({...state, saving: action.product}))
);
